import { useClaimStore, useNotificationStore } from "@/store";

export default function openBoxFolderForCurrentClaim() {
  const boxFolderId = useClaimStore().claim?.boxFolderId;
  if (!boxFolderId) useNotificationStore().emitNotification({
    type: "error",
    title: "Le dossier Box n'est pas encore initialisé"
  });
  else window.open(`https://upclaim.app.box.com/folder/${boxFolderId}`, "_blank")?.focus();
}

export function openBoxSharedFolderForCurrentClaim() {
  const boxFolderId = useClaimStore().claim?.boxFolderIdGeneratedRecevables;
  if (!boxFolderId) useNotificationStore().emitNotification({
    type: "error",
    title: "Le dossier Box partagé n'est pas encore initialisé"
  });
  else window.open(`https://upclaim.app.box.com/folder/${boxFolderId}`, "_blank")?.focus();
}

export function openBoxFile(fileId: string) {
  window.open(`https://upclaim.app.box.com/file/${fileId}`, "_blank")?.focus();
}